import { iconMap } from '../blocks/iconGrid'
import { makeParallax } from 'library/parallax'
// import { default as Fade } from 'react-reveal/Fade'
import { Fade } from 'react-awesome-reveal'
import { AppContext } from '../context/context'
import { Content, H4, TextButton, ButtonBlue } from 'components/common'
import { React, Link, Image, styled, mq } from 'x'
import { useState, useEffect } from 'react'
import { slice, concat } from 'lodash'

import Loading from 'static/svg/loading.svg'
import Arrow from 'static/svg/arrow.svg'
import Chips2 from 'static/artifacts/chips-2.svg'
import BlobBlue from 'static/artifacts/blob-blue.svg'
import LinesSmallYellow from 'static/artifacts/lines-small-yellow.svg'
import LinesAltDark from 'static/artifacts/lines-alt-dark.svg'

const { below } = mq.createBreakpoints({
  itemsMD: '915px',
  itemsLG: '970px',
})

const Container = styled.div`
  @media (min-width: 2000px) {
    max-width: ${(props) => (props.isBlog ? 'auto' : '100%')};
    flex: ${(props) => (props.isBlog ? '0 1 auto' : 'initial')};
  }

  background-color: ${(props) => (props.isBlog ? '#FFF' : '#e9eaee')};
  padding: 60px 0;
  position: relative;
  overflow: hidden;

  max-width: ${(props) => (props.isBlog ? '70%' : '100%')};
  flex: ${(props) => (props.isBlog ? '0 1 70%' : 'initial')};

  ${mq.below('lg')} {
    padding: 50px 0;
  }
  ${mq.below('md')} {
    padding: 50px 0;
    max-width: ${(props) => (props.isBlog ? '100%' : '100%')};
    flex: ${(props) => (props.isBlog ? '1 1 100%' : 'initial')};
  }
  ${mq.below('sm')} {
    padding: 40px 0 40px 0;
  }
`

const ItemContent = styled(Content)`
  overflow: hidden;
  position: relative;
  z-index: 2;
  max-width: ${(props) => (props.isBlog ? '1240px' : '1366px')};
  margin: ${(props) => (props.isBlog ? '0 auto' : '0 auto')};
  padding: ${(props) => (props.isBlog ? '0 30px 0 100px' : '0 100px')};
  margin-top: 35px;
  ${below('itemsMD')} {
    padding: ${(props) => (props.isBlog ? '0 30px' : '0')};
  }
`

const Title = styled(H4)`
  margin-top: 0px;
  margin-bottom: 70px;
  ${mq.below('lg')} {
    margin-bottom: 60px;
  }
  ${mq.below('md')} {
    margin-bottom: 50px;
  }
  ${mq.below('sm')} {
    margin-bottom: 40px;
  }

  ${below('itemsMD')} {
    margin-left: ${(props) => (props.isBlog ? '0' : '5%')};
  }
`

const IconWrapper = styled.div`
  margin-bottom: 25px;
  text-align: left;
`

const ItemContainer = styled.div`
  width: ${(props) => (props.isBlog ? 'auto' : 'calc(100% + 35px)')};
  display: flex;
  flex-wrap: wrap;
  flex-direction: ${(props) => (props.isBlog ? 'row' : 'row')};
  justify-content: ${(props) => (props.isBlog ? 'flex-start' : 'flex-start')};
  box-sizing: border-box;

  ${below('itemsMD')} {
    flex-wrap: ${(props) => (props.isBlog ? 'wrap' : 'flex-wrap: nowrap')};
    justify-content: ${(props) => (props.isBlog ? 'center' : 'flex-start')};
    width: ${(props) => (props.isBlog ? '100%' : '100%')};
    overflow-x: ${(props) => (props.isBlog ? 'visible' : 'scroll')};
    -webkit-overflow-scrolling: touch;
    &:after {
      ${(props) => (props.isBlog ? 'inherit' : 'content:""')};
      ${(props) => (props.isBlog ? 'inherit' : 'flex: 0 0 1px')};
    }
  }

  > .page {
    width: ${(props) => (props.isBlog ? '100%' : '100%')};
    margin: ${(props) => (props.isBlog ? '0 -15px' : 'inherit')};
    display: flex;
    flex-wrap: wrap;
    flex-direction: row;
    justify-content: flex-start;
    box-sizing: border-box;
    ${mq.below('xl')} {
      max-width: ${(props) => (props.isBlog ? '100%' : 'inherit')};
    }

    > .itemWrapper {
      flex: ${(props) => (props.isBlog ? '1 1 33.3336%' : 'inherit')};
      max-width: ${(props) => (props.isBlog ? '33.3336%' : 'inherit')};
      padding: ${(props) => (props.isBlog ? '0 15px' : '0 auto')};
      margin-bottom: ${(props) => (props.isBlog ? '30px' : 'initial')};
      box-sizing: border-box;

      ${mq.below('xl')} {
        flex: ${(props) => (props.isBlog ? '1 1 50%' : 'inherit')};
        max-width: ${(props) => (props.isBlog ? '50%' : 'inherit')};
      }

      ${mq.below('md')} {
        flex: ${(props) => (props.isBlog ? '1 1 100%' : 'inherit')};
        max-width: ${(props) => (props.isBlog ? '100%' : 'inherit')};
      }
    }
  }
`

const Item = styled.div`
  background: #fff;
  box-sizing: border-box;

  /* Bottom includes ItemTextButton which is absolute */
  padding: ${(props) =>
    props.isProspectus
      ? '10px 10px 25px 10px'
      : props.isBlog
      ? '0'
      : '52px 38px 92px 38px'};

  width: ${(props) => (props.isBlog ? '100%' : '364px')};
  margin: ${(props) => (props.isBlog ? '0' : '0 35px 35px 0')};
  position: relative;
  box-shadow: rgba(0, 0, 0, 0.2) 0 4px 10px;
  z-index: 2;
  height: ${(props) => (props.isBlog ? '100%' : 'calc(100% - 50px)')};
  flex: ${(props) => (props.isBlog ? '1 1 100%' : '1 1 100%')};
  max-width: ${(props) => (props.isBlog ? '100%' : 'auto')};

  ${below('itemsLG')} {
    margin: ${(props) => (props.isBlog ? '0' : '0 48px 48px 0')};
    width: ${(props) => (props.isBlog ? '100%' : '300px')};
  }
  ${below('itemsMD')} {
    flex: ${(props) => (props.isBlog ? '1 1 100%' : '0 0 80%')};
    margin-left: ${(props) => (props.isBlog ? '0' : props.isFirst ? '5%' : 0)};
  }
`

const ItemIndex = styled.small`
  display: block;
  font-size: 13px;
  font-weight: 600;
  letter-spacing: 1.2px;
  line-height: 20px;
  padding-bottom: 35px;
  margin-bottom: 35px;
  position: relative;
  color: ${(props) => props.theme.primary};
  &:after {
    content: '';
    width: 20px;
    height: 2px;
    background-color: ${(props) => props.theme.secondary};
    position: absolute;
    bottom: 0;
    left: 0;
  }
`

const ItemHeader = styled.div`
  position: relative;
`

const HeaderImage = styled(Link)`
  position: relative;
  display: block;
  box-sizing: border-box;
  height: 55px;
  max-width: 50%;
  right: 0;
  top: 0;
  margin-bottom: 20px;
`

const HeaderThumb = styled(Link)`
  height: 55px;
  margin-bottom: 25px;
  display: block;
`

const ItemTitle = styled(Link)`
  display: block;
  font-size: 24px;
  font-weight: 600;
  line-height: 30px;
  color: ${(props) => props.theme.primary};
  text-transform: uppercase;
  margin-bottom: 16px;
`

const ItemSummary = styled.div`
  font-size: 16px;
  line-height: 28px;
  color: ${(props) => props.theme.primary};
  margin: 16px 0 42px 0;

  b,
  strong {
    font-weight: 600;
  }

  a {
    color: ${(props) => props.theme.primary};
    text-decoration: underline;
  }
`

const ItemTextButton = styled(TextButton)`
  position: absolute;
  bottom: 42px;
  padding: 10px 28px 10px 0;
  color: ${(props) => props.theme.secondary};
  & > .arrow {
    fill: ${(props) => props.theme.secondary};
    top: 15px;
  }
  &:hover {
    color: #eda331;
  }
`

const ArtifactA = makeParallax(styled.div`
  position: absolute;
  right: 20px;
  top: 430px;
  z-index: 1;

  ${mq.below('xl')} {
    display: none;
  }
`)

const ArtifactB = makeParallax(styled.div`
  position: absolute;
  left: -20px;
  top: 720px;
  z-index: 1;

  ${mq.below('xl')} {
    display: none;
  }
`)

const ArtifactC = styled.div`
  position: absolute;
  left: 20%;
  top: -60px;
  z-index: 1;
  transform: rotate(35deg);

  ${mq.below('xl')} {
    display: none;
  }
`

const BackgroundHeader = styled.div`
  height: 150px;
  position: relative;
  width: 100%;
  padding: 0px 38px 0px 38px;
  margin-left: -38px;
  margin-top: -62px;
  margin-bottom: 35px;
`

const BackgroundHeaderImage = styled.div`
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  z-index: 1;
`

const BackgroundHeaderGradient = styled(Link)`
  background: radial-gradient(
    circle at center,
    rgba(0, 0, 0, 0.2) 50%,
    transparent 140%
  );
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  z-index: 2;
`

const BackgroundIndex = styled.small`
  display: block;
  font-size: 16px;
  font-weight: 600;
  letter-spacing: 1.2px;
  position: absolute;
  padding: 30px;
  top: 0;
  left: 0;
  color: #fff;
  z-index: 3;
  &:after {
    content: '';
    width: 20px;
    height: 2px;
    background-color: ${(props) => props.theme.secondary};
    position: absolute;
    bottom: 0;
    left: 30px;
  }
`

const PdfBlock = styled.div`
  max-width: 315px;
  padding: 10px;
  background: #fff;
  margin: 0 auto;
  box-shadow: 0 4px 10px 0px rgba(0, 0, 0, 0.57);
  transition: transform 0.2s ease-out;

  &:hover {
    transform: scale(1.05);
  }
`

// Blog styles

const BlogInner = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
`

const ImageWrapper = styled.div`
  flex: 1 1 100%;
  max-width: 100%;
  height: 100%;
  margin: 0 auto;
  padding: 0;
  box-sizing: border-box;
`

const BlogLink = styled(Link)`
  display: block;
  box-sizing: border-box;
  height: 100%;
  width: 100%;
  margin-bottom: -5px;
`

const BlogContent = styled.div`
  height: 100%;
  flex: 1 1 100%;
  max-width: 100%;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: flex-start;
  padding: 30px 20px;
`

const BlogDate = styled.p`
  color: black;
`

const BlogTitle = styled(ItemTitle)`
  font-size: 20px;
  line-height: 24px;
  font-weight: 700;
  text-transform: capitalize;
  margin-bottom: 10px;
`

const BlogSummary = styled(ItemSummary)`
  margin-top: 0;
  margin-bottom: 0;
  > p,
  > h1,
  > h2,
  > h3,
  > h4,
  > h5,
  > h6 {
    margin-top: 0;
    font-size: 16px !important;
    line-height: 28px !important;
    font-weight: normal !important;
  }
`

const Topics = styled.p`
  margin-top: 0;
  margin-bottom: 10px;
`

const Topic = styled(Link)`
  display: inline-block;
  padding-right: 10px;
  color: #979090;
  padding-right: 8px;
  font-size: 14px;
  line-height: 20px;
  &:hover {
    color: black;
  }
`

const ItemBlogButton = styled(TextButton)`
  position: relative;
  width: auto;
  color: ${(props) => props.theme.secondary};
  > .arrow {
    fill: ${(props) => props.theme.secondary};
  }
`

const LoadMoreButton = styled(ButtonBlue)`
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding-right: 30px;

  > span {
    padding-right: 30px;
  }
`

const LoadingIcon = styled(Loading)`
  fill: white;
`

const renderIcon = (name) => {
  const Icon = iconMap?.[name] ?? iconMap['time']
  return (
    <IconWrapper>
      <Icon width={70} />
    </IconWrapper>
  )
}

const Empty = styled.div``

const Subitems = (props) => {
  const globalData = props.globalData
  const relationId = props.post.id
  const title = props.data.title
  const titleElement =
    props.data.titleElement && props.data.titleElement !== 'default'
      ? props.data.titleElement
      : 'h4'
  const formatLink = props.globalData.formatLink

  let extraKey = do {
    if (props.post.layout === 'accreditors') 'courses'
    else if (props.post.layout === 'categories') 'accreditors'
    else if (
      props.post.layout === 'page' &&
      props.post.acf.pageLayout === 'content'
    )
      'pages'
    else if (
      props.post.layout === 'page' &&
      props.post.acf.pageLayout === 'career_overview'
    )
      'careers'
    else if (
      props.post.layout === 'page' &&
      props.post.acf.pageLayout === 'courses'
    )
      'courseCategories'
    else if (
      props.post.layout === 'page' &&
      props.post.acf.pageLayout === 'offer_overview'
    )
      'offerCategories'
    else if (props.post.layout === 'offer_categories') 'offers'
    else if (
      props.post.layout === 'page' &&
      props.post.acf.pageLayout === 'blog_overview'
    )
      'blog'
    else if (props.post.layout === 'blog_topics') 'blog'
    else if (
      props.post.layout === 'page' &&
      props.post.acf.pageLayout === 'prospectuses_overview'
    )
      'prospectuses'
    else if (
      props.post.layout === 'page' &&
      props.post.acf.pageLayout === 'landing_page'
    )
      'landingPage'
  }

  var nodes = props.extra[extraKey]

  const isSmall = typeof window !== 'undefined' && window.innerWidth <= 544

  //  Load more functionality for posts
  const LENGTH = nodes.length
  const LIMIT = 1

  const DATA = [...nodes]
  const paginatedDATA = []

  while (DATA.length) {
    paginatedDATA.push(DATA.splice(0, 9))
  }

  const [showMore, setShowMore] = useState(true)
  const [list, setList] = useState(slice(paginatedDATA, 0, LIMIT))
  const [index, setIndex] = useState(LIMIT)

  const [currentPage, setCurrentPage] = React.useContext(AppContext)

  const loadMore = (e, pageIndex) => {
    if (!pageIndex && e !== null) {
      e.preventDefault()
      const newIndex = index + LIMIT
      const newShowMore = newIndex < LENGTH - 1
      const newList = concat(list, slice(paginatedDATA, index, newIndex))
      setCurrentPage(newIndex)
      setIndex(newIndex)
      setList(newList)
      setShowMore(newShowMore)
      const url = new URL(window.location)
      url.searchParams.set('page', newIndex)
      window.history.pushState({}, '', url)
    } else {
      const newShowMore = pageIndex < LENGTH - 1
      const newList = concat(list, slice(paginatedDATA, index, pageIndex))

      setIndex(pageIndex)
      setList(newList)
      setShowMore(newShowMore)
      setCurrentPage(parseInt(pageIndex))
      setIndex(pageIndex)
      const url = new URL(window.location)
      url.searchParams.set('page', pageIndex)
      window.history.pushState({}, '', url)
    }
    //document.location.href = `${window.location.pathname}?page=${newIndex}`
  }

  useEffect(() => {
    const url = new URL(window.location)
    let pageIndex = parseInt(url.searchParams.get('page'))

    if (pageIndex > 1) {
      loadMore(null, pageIndex)

      setTimeout(() => {
        if (document.getElementById(`#page_pag${pageIndex}`)) {
          document
            .getElementById(`#page_pag${pageIndex}`)
            .scrollIntoView({ behavior: 'smooth' })
        }
      }, 1000)
    }
  }, [])

  const setPageData = (e, pageData) => {
    e.preventDefault()
    setcurrentPage(pageData)
  }

  const sum_length = 120

  if (extraKey === 'blog' || extraKey === 'blogTopics') {
    return (
      <Container isBlog={extraKey === 'blog'}>
        <ItemContent isBlog={extraKey === 'blog'}>
          {title && (
            <Title as={titleElement} line={true}>
              {title}
            </Title>
          )}
          <ItemContainer isBlog={extraKey === 'blog'}>
            {list &&
              list.map((page, idx) => {
                return (
                  <div
                    className="page pagination_page"
                    key={idx}
                    id={'#page_pag' + (idx + 1)}
                    data-page-index={idx + 1}
                    data-page-url={`page-${idx + 1}`}
                  >
                    {page.map((node, index) => {
                      return (
                        <Fade
                          key={node.id}
                          delay={(index % 3) * 200}
                          className="itemWrapper"
                          isBlog={extraKey === 'blog'}
                          data-page-url={`page-${idx + 1}`}
                        >
                          <Item
                            key={'item-' + node.id}
                            isFirst={index === 0}
                            isLast={index === nodes.length - 1}
                            isProspectus={extraKey === 'prospectuses'}
                            isBlog={extraKey === 'blog'}
                          >
                            <BlogInner>
                              <ImageWrapper>
                                <BlogLink
                                  to={props.globalData.formatLink(node.link)}
                                >
                                  {node.acf.image?.imgixImageWp?.fixed && (
                                    <Image
                                      fixed={node.acf.image.imgixImageWp.fixed}
                                      style={{
                                        height: 'auto',
                                        minHeight: '250px',
                                        maxWidth: '100%',
                                      }}
                                      className="lazyload"
                                    />
                                  )}
                                </BlogLink>
                              </ImageWrapper>
                              <BlogContent>
                                <BlogDate>{node.date}</BlogDate>
                                <BlogTitle
                                  to={props.globalData.formatLink(node.link)}
                                >
                                  {node.title}
                                </BlogTitle>
                                {node.acf && node.acf.summary && (
                                  <BlogSummary
                                    dangerouslySetInnerHTML={{
                                      __html:
                                        node.acf.summary.slice(0, sum_length) +
                                        '...',
                                    }}
                                  />
                                )}
                                {node?.acf && node?.acf?.relationId && (
                                  <Topics>
                                    {node.acf.relationId.map((topic, index) => (
                                      <Topic
                                        key={topic.id}
                                        to={props.globalData.formatLink(
                                          topic.url
                                        )}
                                      >
                                        {topic.name}
                                      </Topic>
                                    ))}
                                  </Topics>
                                )}
                                <ItemBlogButton to={formatLink(node.link)}>
                                  Read blog
                                  <Arrow className="arrow" />
                                </ItemBlogButton>
                              </BlogContent>
                            </BlogInner>
                          </Item>
                        </Fade>
                      )
                    })}
                  </div>
                )
              })}
          </ItemContainer>
        </ItemContent>
        <Content
          style={{ display: 'flex', justifyContent: 'center' }}
          isBlog={extraKey === 'blog'}
        >
          {showMore && list.length ? (
            <LoadMoreButton style={{ zIndex: 1 }} onClick={loadMore}>
              {' '}
              <span>Load More</span> <LoadingIcon className="loading" />
            </LoadMoreButton>
          ) : null}
        </Content>
      </Container>
    )
  } else {
    return (
      <Container>
        <ItemContent>
          {title && (
            <Title as={titleElement} line={true}>
              {title}
            </Title>
          )}
          <ItemContainer>
            {nodes &&
              nodes.map((node, index) => {
                // const Fader = isSmall && index < 2 ? Empty : Fade
                // const Fader = Fade

                return (
                  <Fade key={node.id} delay={(index % 3) * 200}>
                    <Item
                      key={'item-' + node.id}
                      isFirst={index === 0}
                      isLast={index === nodes.length - 1}
                      isProspectus={extraKey === 'prospectuses'}
                    >
                      {node.acf && node.acf.image?.imgixImageWp ? (
                        <BackgroundHeader>
                          <Image
                            fixed={node.acf.image.imgixImageWp.fixed}
                            style={{
                              height: 'auto',
                              width: '100%',
                              position: 'absolute',
                              top: 0,
                              right: 0,
                              bottom: 0,
                              left: 0,
                            }}
                          />
                          <BackgroundHeaderGradient
                            to={props.globalData.formatLink(node.link)}
                          />
                        </BackgroundHeader>
                      ) : node.acf && node.acf.icon ? (
                        renderIcon(node.acf.icon)
                      ) : extraKey === 'prospectuses' ? (
                        <a href={node.acf.pdf} target="_blank">
                          {node.acf.thumb?.imgixImageWp && (
                            <Image fixed={node.acf.thumb.imgixImageWp.fixed} />
                          )}
                        </a>
                      ) : node.acf.thumb ? (
                        <BackgroundHeader>
                          <Image
                            fixed={node.acf.thumb.imgixImageWp.fixed}
                            style={{
                              height: 'auto',
                              width: '100%',
                              position: 'absolute',
                              top: 0,
                              right: 0,
                              bottom: 0,
                              left: 0,
                            }}
                          />
                          <BackgroundHeaderGradient
                            to={props.globalData.formatLink(node.link)}
                          />
                        </BackgroundHeader>
                      ) : (
                        <ItemHeader>
                          {node.acf && node.acf.thumbnail?.imgixImageWp && (
                            <HeaderImage
                              to={props.globalData.formatLink(node.link)}
                              style={{
                                height: '55px',
                              }}
                            >
                              <Image
                                fixed={node.acf.thumbnail.imgixImageWp.fixed}
                                style={{
                                  width: '100%',
                                  height: '100%',
                                }}
                                imgStyle={{
                                  objectFit: 'contain',
                                  objectPosition: 'left top',
                                }}
                                objectFit="contain"
                                objectPosition="left top"
                              />
                            </HeaderImage>
                          )}
                        </ItemHeader>
                      )}
                      {extraKey !== 'prospectuses' && (
                        <>
                          <ItemTitle
                            to={props.globalData.formatLink(node.link)}
                          >
                            {node.title}
                          </ItemTitle>
                          {node.acf && node.acf.summary && (
                            <ItemSummary
                              dangerouslySetInnerHTML={{
                                __html: node.acf.summary,
                              }}
                            />
                          )}
                          <ItemTextButton to={formatLink(node.link)}>
                            {props.globalData.stringFindOutMore}
                            <Arrow className="arrow" />
                          </ItemTextButton>
                        </>
                      )}
                    </Item>
                  </Fade>
                )
              })}
          </ItemContainer>
        </ItemContent>
        <ArtifactA offset={120}>
          <Chips2 width={230} />
        </ArtifactA>
        <ArtifactB offset={80}>
          <LinesAltDark width={160} />
        </ArtifactB>
        <ArtifactC>
          <BlobBlue width={160} />
        </ArtifactC>
      </Container>
    )
  }
}

export default Subitems
